import React from 'react';
import DocumentEditorComponent from '../components/DocumentEditor';

const DocumentEditor = () => {
  return <DocumentEditorComponent />;
};

export default DocumentEditor;